// components/voice/VoiceHeader.tsx
import { Bot, User, Mic, XCircle, X } from 'lucide-react';
import { AgentInfo, ChatMode, ConnectionState } from '../../contexts/voice/types';

interface VoiceHeaderProps {
  currentAgent: AgentInfo;
  statusText: string;
  chatMode: ChatMode;
  state: ConnectionState;
  hasMessages: boolean;
  onSwitchToVoice: () => void;
  onCloseChat: () => void;
  onCollapse: () => void;
}

export function VoiceHeader({
  currentAgent,
  statusText,
  chatMode,
  state,
  hasMessages,
  onSwitchToVoice,
  onCloseChat,
  onCollapse,
}: VoiceHeaderProps) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-primary/10 bg-card">
      <div className="flex items-center gap-3">
        <div className={`relative flex items-center justify-center w-10 h-10 rounded-full ${
          currentAgent.type === 'human' ? 'bg-green-500' : 'bg-primary'
        }`}>
          {currentAgent.type === 'human' ? (
            <User className="w-5 h-5 text-white" />
          ) : (
            <Bot className="w-5 h-5 text-white" />
          )}
        </div>
        <div>
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-foreground">{currentAgent.name}</span>
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              currentAgent.type === 'human'
                ? 'bg-green-100 text-green-700'
                : 'bg-primary/10 text-primary'
            }`}>
              {currentAgent.role}
            </span>
          </div>
          <p className="text-xs text-muted-foreground">{statusText}</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        {/* Call button - only in text mode */}
        {chatMode === 'text' && state !== 'disconnected' && (
          <button
            onClick={onSwitchToVoice}
            className="p-2 rounded-lg hover:bg-primary/10 text-primary hover:text-primary/80 transition-colors"
            title="Schakel naar spraak"
          >
            <Mic className="w-4 h-4" />
          </button>
        )}
        {/* End chat button - only in text mode with messages */}
        {chatMode === 'text' && state !== 'disconnected' && hasMessages && (
          <button
            onClick={onCloseChat}
            className="p-2 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/30 text-red-500 hover:text-red-600 transition-colors"
            title="Einde chat"
          >
            <XCircle className="w-4 h-4" />
          </button>
        )}
        <button
          onClick={onCollapse}
          className="p-2 rounded-lg hover:bg-primary/10 text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
